import classNames from "classnames";
import { UserDetailsTextProps } from "../types";
import React from "react";

export function UserDetailsText({
  textAlign,
  hasName,
  hasJobTitle,
  hasCompany,
  name,
  jobTitle,
  company,
  styleType,
  primaryColor,
  secondaryColor,
  primaryFontSize,
  secondaryFontSize
}: UserDetailsTextProps) {
  return (
    <div className="userDetailText" style={{ textAlign: textAlign || "left" }}>
      {hasName && (
        <span
          className={classNames("userDetailText--text line-clamp-1", `${styleType}_primary`)}
          style={
            {
              "--userDetailTextFontSize": primaryFontSize + "px",
              "--userDetailTextColor": primaryColor
            } as any
          }>
          {name}
        </span>
      )}
      {hasJobTitle && (
        <span
          className={classNames("userDetailText--text line-clamp-1", `${styleType}_secondary`)}
          style={
            {
              "--userDetailTextFontSize": secondaryFontSize + "px",
              "--userDetailTextColor": secondaryColor
            } as any
          }>
          {jobTitle}
        </span>
      )}
      {hasCompany && (
        <span
          className={classNames("userDetailText--text line-clamp-1", `${styleType}_secondary`)}
          style={
            {
              "--userDetailTextFontSize": secondaryFontSize + "px",
              "--userDetailTextColor": secondaryColor
            } as any
          }>
          {company}
        </span>
      )}
    </div>
  );
}
